import { ProtectedRoute } from "@/components/protected-route";
import { useSession } from "@/services/auth0/session";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router";
import { Button } from "@/components/ui/button";
import { useAuth0 } from "@auth0/auth0-react";

export function OnboardingLayout() {
  const { customer } = useSession();
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const location = useLocation();

  // Define steps with their specific configurations
  const STEPS = [
    {
      path: "/onboarding/step-1",
      title: "Profile",
      header: {
        title: "Create Profile",
        actions: (
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => logout()}>
              Logout
            </Button>
          </div>
        ),
      },
    },
    {
      path: "/onboarding/step-2",
      title: "First Order",
      header: {
        title: "Place First Order",
        actions: (
          <div className="flex gap-2">
            <Button
              variant="outline"
              onClick={() => navigate("/onboarding/success")}
            >
              Skip
            </Button>
            <Button variant="outline" onClick={() => logout()}>
              Logout
            </Button>
          </div>
        ),
      },
    },
    {
      path: "/onboarding/success",
      title: "Complete",
      header: {
        title: "All set!",
      },
    },
  ];

  // Get current step based on path
  const currentStepIndex = STEPS.findIndex((step) =>
    location.pathname.includes(step.path)
  );
  const currentStep = STEPS[currentStepIndex] || STEPS[0]; // Default to first step if none found

  if (customer?.sentOrders?.length && customer?.sentOrders?.length > 0) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <ProtectedRoute>
      <div className="bg-white flex flex-col flex-1 min-h-screen">
        <div className="sticky py-3 sm:py-6 top-0 z-50 bg-white shadow-md flex flex-col gap-3 sm:gap-5 px-4 lg:px-8 w-full">
          <div className="flex flex-row justify-between items-center">
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900 mr-4">
              {currentStep?.header.title}
            </h1>
            {currentStep?.header.actions}
          </div>

          {/* Progress bar */}
          <div className="w-full pb-2">
            <div className="flex justify-between mb-1.5 sm:mb-2">
              {STEPS.map((step, index) => (
                <span
                  key={step.path}
                  className={`text-xs sm:text-sm font-medium ${
                    index <= currentStepIndex
                      ? "text-primary font-semibold"
                      : "text-gray-400"
                  }`}
                >
                  {step.title}
                </span>
              ))}
            </div>
            <div className="w-full h-1.5 sm:h-2 bg-gray-100 rounded-full">
              <div
                className="h-full bg-primary rounded-full transition-all duration-300"
                style={{
                  width: `${((currentStepIndex + 1) / STEPS.length) * 100}%`,
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col flex-1 pt-4 sm:pt-6 mx-auto w-full">
          <Outlet />
        </div>
      </div>
    </ProtectedRoute>
  );
}
